// extracted by mini-css-extract-plugin
module.exports = {"expander":"Expander_expander__c1BMs","panel":"Expander_panel__JcRNc","title":"Expander_title__38vA9"};